import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams, RequestOptions, ResponseContentType } from '@angular/http';
import { CommonService } from './common.service';
import { RecordKeeper } from './../models/index';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root'
})
export class RecordkeeperService {
  private url = CommonService.getEwdApiURL() + 'recordkeeper';

  constructor(
    private http: Http,
    private errorService: ErrorService
  ) { }

  getAll() {
    return this.http.get(this.url).map(
      (response: Response) => response.json()
      );
  }

  get(id: number) {
    return this.http.get(this.url + '/' + id).map(
      (response: Response) => response.json()
      );
  }

  searchRecordKeepers(searchString): Observable<RecordKeeper[]> {
    return this.http.get(this.url + '/search?s=' + searchString)
        .map((response: Response) => {
            if (response.status === 204) {
              this.errorService.handleError(response);
            };
            return response.json();
        });
  }

  add(recordKeeper): Observable<number> {
    return this.http.post(this.url, recordKeeper).map(
      (response: Response) => response.json()
      );
  }

  update(id, recordKeeper): Observable<boolean> {
    return this.http.put(this.url + '/' + id, recordKeeper).map(
      (response: Response) => {
        return true;
      });
  }

  delete(id): Observable<Boolean> {
    return this.http.delete(this.url + '/' + id).map(
      (response: Response) => {
        return true;
      });
  }

}
